import React from 'react';
import { Table } from 'reactstrap';
import moment from 'moment';
import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import { LoaderMini } from '~/components/Loaders';
import {
	TdExtrato,
	TrExtrato,
	ThExtrato,
	TheadExtrato,
	TbodyExtrato
} from './styles';



export function ExtratoIndustria(props) {
	const { extratos, loading } = props;

	return (
		<>
			{loading ? (
				<LoaderMini />
			) : (
				<Table id="test-table-xls-button" responsive>
					<TheadExtrato>
						<TrExtrato>
							<>
								<ThExtrato>Data da transação</ThExtrato>
								<ThExtrato>Farmácia</ThExtrato>
								<ThExtrato>Distribuidor</ThExtrato>
								<ThExtrato>NSU</ThExtrato>
								<ThExtrato>V. Bruto</ThExtrato>
								<ThExtrato>Saldo Farmácia</ThExtrato>
								<ThExtrato>Saldo Distribuidor</ThExtrato>
							</>
						</TrExtrato>
					</TheadExtrato>
					<TbodyExtrato>
						{extratos.map((item, index) => {
							return (
								<>
									<TrExtrato key={`${item.numero_documento}-${index}`}>
										<TdExtrato>
										{moment(item.data_transacao).format(
											'DD/MM/YYYY HH:mm'
										)}
										</TdExtrato>
										<TdExtrato>{item.nome_revenda}</TdExtrato>
										<TdExtrato style={{ textAlign: 'left' }}>{item.nome_distribuidor}</TdExtrato>
										<TdExtrato style={{ textAlign: 'left' }}>{item.nsu_adquirente}</TdExtrato>
										<TdExtrato>{item.valor_transacao ? symbolPriceFormatter(item.valor_transacao) : '-'}</TdExtrato>
										<TdExtrato>{item.credito_revenda ? symbolPriceFormatter(item.credito_revenda) : '-'}</TdExtrato>
										<TdExtrato style={{ color: color.green }}>
											{item.credito_distribuidor ? symbolPriceFormatter(item.credito_distribuidor) : '-'}
										</TdExtrato>
									</TrExtrato>
								</>
							);
						})}
					</TbodyExtrato>
				</Table>
			)}
		</>
	);
}
